import { LanderRequest } from '@/app/modules/lander/LanderRequest';
import { landerApiSendLead } from '@/shared/lib/domains/lander/landerApiSendLead';
import { landMap } from '@/shared/lib/domains/invite/inviteSetupFormSubmit';
import { projectName } from '@/shared/constants/system';
import {
  landerSourceName,
  landerUtmSource,
} from '@/shared/lib/domains/lander/landerConstants';
import { landerDataBuildMergeLead } from '@/shared/lib/domains/lander/landerDataBuildMergeLead';
import { MERGE_LEAD_KEY } from '@/shared/api';
import { cardSetupProperties } from '@/shared/lib/domains/card/cardSetupProperties';
import { registerApplier } from '@/app/libs/I';
import { landerRequestService } from '@/app/modules/lander/LanderRequestService';

registerApplier(landerRequestService.applierId, async (model: LanderRequest) => {
  const mergeLead = landerDataBuildMergeLead();
  const { number } = cardSetupProperties();
  return await landerApiSendLead({
    params: {
      land: landMap[projectName] ?? 'sf_referral',
      sourceName: landerSourceName,
      utm_source: landerUtmSource,
      ...model.params,
    },
    payload: {
      [MERGE_LEAD_KEY]: mergeLead,
      partner: number,
      ...model.payload,
    },
  },
  model.withError,
  );
});
